export type AddressBookErrorCode =
  | 'ADDRESS_BOOK_ENTRY_NAME_REQUIRED'
  | 'ADDRESS_BOOK_ENTRY_CONTACT_REQUIRED'
  | 'ADDRESS_BOOK_ENTRY_ID_REQUIRED'
  | 'ADDRESS_BOOK_ORGANIZATION_REQUIRED'
  | 'ADDRESS_BOOK_LIMIT_REACHED'
  | 'ADDRESS_BOOK_ADD_FAILED'
  | 'ADDRESS_BOOK_UPDATE_FAILED'
  | 'ADDRESS_BOOK_REMOVE_FAILED';

export class AddressBookError extends Error {
  public readonly code: AddressBookErrorCode;

  constructor(code: AddressBookErrorCode, message?: string) {
    super(message || code);
    this.name = 'AddressBookError';
    this.code = code;
  }

  static entryNameRequired(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_ENTRY_NAME_REQUIRED');
  }

  static entryContactRequired(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_ENTRY_CONTACT_REQUIRED');
  }

  static entryIdRequired(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_ENTRY_ID_REQUIRED');
  }

  static organizationRequired(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_ORGANIZATION_REQUIRED');
  }

  static limitReached(limit: number): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_LIMIT_REACHED', `Address book limit of ${limit} reached`);
  }

  static addFailed(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_ADD_FAILED');
  }

  static updateFailed(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_UPDATE_FAILED');
  }

  static removeFailed(): AddressBookError {
    return new AddressBookError('ADDRESS_BOOK_REMOVE_FAILED');
  }
}
